// extracted by mini-css-extract-plugin
module.exports = {"templateListingContainer":"Templates_templateListingContainer__18zSP","selectedTemplateContainer":"Templates_selectedTemplateContainer__3DaYQ","editBtn":"Templates_editBtn__2r80f"};